import { render, staticRenderFns } from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=template&id=0e24707a"
import script from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=script&lang=js"
export * from "./AcademicPerformanceEvaluationGeneralInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports